import Link from 'components/links/Link';
import { MalaPuscicaDesno } from 'kzv-icons';
import PropTypes from 'prop-types';
import React, { useEffect } from 'react';
import { Mixpanel } from 'utils/Mixpanel';

function Divider() {
    return <MalaPuscicaDesno />;
}

const styles = 'hover:underline';

function Breadcrumbs({ crumbs }) {
    useEffect(() => {
        Mixpanel.trackLinks('.breadcrumbs a', 'Clicked breadcrumb link');
    }, []);

    return (
        <div className="breadcrumbs flex items-center space-x-2 text-secondary text-sm leading-none">
            {crumbs.map((c, index) => (
                <React.Fragment key={index}>
                    <span className="whitespace-nowrap overflow-hidden overflow-ellipsis">
                        <Link to={c.link} styles={styles}>
                            {c.label}
                        </Link>
                    </span>
                    {index + 1 !== crumbs.length && <Divider />}
                </React.Fragment>
            ))}
        </div>
    );
}

Breadcrumbs.propTypes = {
    crumbs: PropTypes.arrayOf(
        PropTypes.shape({
            label: PropTypes.string,
            link: PropTypes.string
        })
    )
};

export default Breadcrumbs;
